import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { AudioProvider } from './contexts/AudioContext';
import { Layout } from './components/Layout';
import { Toaster } from './components/ui/sonner';
import WelcomeModal from './components/WelcomeModal';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Programme from './pages/Programme';
import Methode from './pages/Methode';
import ChapterDetail from './pages/ChapterDetail';
import Outils from './pages/Outils';
import ToolDetail from './pages/ToolDetail';
import Suivi from './pages/Suivi';
import Aide from './pages/Aide';
import Stats from './pages/Stats';
import Downloads from './pages/Downloads';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import Admin from './pages/Admin';
import AdminCodes from './pages/AdminCodes';
import AdminContents from './pages/AdminContents';
import AdminThemes from './pages/AdminThemes';
import AdminChapters from './pages/AdminChapters';
import AdminTools from './pages/AdminTools';
import AdminHelp from './pages/AdminHelp';
import AdminAnnouncements from './pages/AdminAnnouncements';
import AdminAudioUpload from './pages/AdminAudioUpload';
import AdminTestimonials from './pages/AdminTestimonials';
import MentionsLegales from './pages/MentionsLegales';
import CGV from './pages/CGV';
import CGU from './pages/CGU';
import Confidentialite from './pages/Confidentialite';
import Quiz from './pages/Quiz';
import QueFaireSi from './pages/QueFaireSi';
import MangeTropVite from './pages/MangeTropVite';
import ChecklistSoir from './pages/ChecklistSoir';
import ChecklistSoirFree from './pages/ChecklistSoirFree';
import MangeTropViteFree from './pages/MangeTropViteFree';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-sage-700 font-sans">Chargement...</p>
      </div>
    );
  }

  return user ? children : <Navigate to="/login" />;
};

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-sage-700 font-sans">Chargement...</p>
      </div>
    );
  }

  return user?.is_admin ? children : <Navigate to="/programme" />;
};

function AppContent() {
  const { user } = useAuth();
  
  return (
    <>
      <Layout>
        <Routes>
          {/* Route publique - Page d'accueil */}
          <Route path="/" element={<Landing />} />
          <Route path="/landing" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />

        <Route
          path="/programme"
          element={
            <ProtectedRoute>
              <Programme />
            </ProtectedRoute>
          }
        />

        <Route
          path="/methode"
          element={
            <ProtectedRoute>
              <Methode />
            </ProtectedRoute>
          }
        />

        <Route
          path="/methode/:slug"
          element={
            <ProtectedRoute>
              <ChapterDetail />
            </ProtectedRoute>
          }
        />

        <Route
          path="/outils"
          element={
            <ProtectedRoute>
              <Outils />
            </ProtectedRoute>
          }
        />

        <Route
          path="/outils/:slug"
          element={
            <ProtectedRoute>
              <ToolDetail />
            </ProtectedRoute>
          }
        />

        <Route
          path="/suivi"
          element={
            <ProtectedRoute>
              <Suivi />
            </ProtectedRoute>
          }
        />

        <Route
          path="/aide"
          element={
            <ProtectedRoute>
              <Aide />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin"
          element={
            <AdminRoute>
              <Admin />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/codes"
          element={
            <AdminRoute>
              <AdminCodes />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/contents"
          element={
            <AdminRoute>
              <AdminContents />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/contents/themes"
          element={
            <AdminRoute>
              <AdminThemes />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/contents/chapters"
          element={
            <AdminRoute>
              <AdminChapters />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/contents/tools"
          element={
            <AdminRoute>
              <AdminTools />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/contents/help"
          element={
            <AdminRoute>
              <AdminHelp />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/announcements"
          element={
            <AdminRoute>
              <AdminAnnouncements />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/audio"
          element={
            <AdminRoute>
              <AdminAudioUpload />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/testimonials"
          element={
            <AdminRoute>
              <AdminTestimonials />
            </AdminRoute>
          }
        />

        <Route
          path="/stats"
          element={
            <ProtectedRoute>
              <Stats />
            </ProtectedRoute>
          }
        />

        <Route
          path="/downloads"
          element={
            <ProtectedRoute>
              <Downloads />
            </ProtectedRoute>
          }
        />

        {/* Pages légales (publiques) */}
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/cgv" element={<CGV />} />
        <Route path="/cgu" element={<CGU />} />
        <Route path="/confidentialite" element={<Confidentialite />} />
        <Route path="/gratuit/checklist" element={<ChecklistSoirFree />} />
        <Route path="/gratuit/mange-trop-vite" element={<MangeTropViteFree />} />
        <Route
          path="/quiz"
          element={
            <ProtectedRoute>
              <Quiz />
            </ProtectedRoute>
          }
        />
        <Route
          path="/outils/que-faire-si"
          element={
            <ProtectedRoute>
              <QueFaireSi />
            </ProtectedRoute>
          }
        />
        <Route
          path="/outils/mange-trop-vite"
          element={
            <ProtectedRoute>
              <MangeTropVite />
            </ProtectedRoute>
          }
        />
        <Route
          path="/outils/checklist-soir"
          element={
            <ProtectedRoute>
              <ChecklistSoir />
            </ProtectedRoute>
          }
        />
        </Routes>
      </Layout>
      {/* Modal de bienvenue pour les nouveaux utilisateurs */}
      {user && <WelcomeModal user={user} />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AudioProvider>
          <AppContent />
          <Toaster position="top-center" />
        </AudioProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;